import React, { useState, useEffect, useRef } from 'react'
import '../layouts/Header.css'

import { BsSearch } from 'react-icons/bs'
import { BiChevronDown } from 'react-icons/bi'
import { IoStar } from 'react-icons/io5'
import { FiUser } from 'react-icons/fi'

import { Link } from 'react-router-dom'
import Axios from 'axios'

import { API_URL } from '../config'

const url = `${API_URL}/apps/kscanner`

export default function Header() {
  const dropdownRef = useRef(null)
  const searchRef = useRef(null)

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [queryResults, setQueryResults] = useState([])
  const [searchOpen, setSearchOpen] = useState(false)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }

      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const toggleDropdown = () => {
    setDropdownOpen((current) => !current)
  }

  const clearSearch = () => {
    setSearch('')
    setQueryResults([])
    setSearchOpen(false)
  }

  const handleSearch = async (event) => {
    const searchVal = event.target.value

    setSearch(searchVal)

    if (!searchVal.trim()) {
      setQueryResults([])
      setSearchOpen(false)
      return
    }

    setSearchOpen(true)

    try {
      const response = await Axios.get(
        `${url}/webservices.php?query=SEARCHEVENTS&search=${encodeURIComponent(searchVal)}`,
        {
          withCredentials: true,
        },
      )

      if (response.data.val === 0 || response.data.val == 0) {
        setQueryResults([])
      } else {
        setQueryResults(Array.isArray(response.data) ? response.data : [])
      }
    } catch (error) {
      console.error('Search request failed:', error)
      setQueryResults([])
    }
  }

  const date = new Date()
  const day = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  const fulldate = `${year}-${month}-${day}`

  return (
    <header className="kx-header">
      <div className="kx-header__inner">
        {/* =====================================================
            BRAND
        ===================================================== */}

        <Link to="/" className="kx-header__brand">
          <span className="kx-header__brand-name">
            karamale<span>.</span>
          </span>
        </Link>

        {/* =====================================================
            SEARCH
        ===================================================== */}

        <div className="kx-header__search" ref={searchRef}>
          <div
            className={`kx-header__search-box ${searchOpen ? 'kx-header__search-box--active' : ''}`}
          >
            <BsSearch className="kx-header__search-icon" size={16} />

            <input
              type="text"
              placeholder="Search Karamale"
              value={search}
              onChange={handleSearch}
              onFocus={() => {
                if (search.trim()) {
                  setSearchOpen(true)
                }
              }}
              autoComplete="off"
            />

            {search && (
              <button type="button" className="kx-header__search-clear" onClick={clearSearch}>
                ×
              </button>
            )}
          </div>

          {searchOpen && (
            <div className="kx-header__search-results">
              {queryResults.length < 1 ? (
                <div className="kx-header__no-results">
                  <span className="kx-header__no-results-title">No events found</span>

                  <span>Try searching for another event.</span>
                </div>
              ) : (
                queryResults.map((item, index) => {
                  if (item.indexid >= 1) {
                    return null
                  }

                  const posterUri = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`

                  const eventName =
                    item.event_name && item.event_name.length > 27
                      ? `${item.event_name.substr(0, 27)}...`
                      : item.event_name

                  const businessName =
                    item.businessname && item.businessname.length > 30
                      ? `${item.businessname.substr(0, 30)}...`
                      : item.businessname

                  return (
                    <Link
                      key={index}
                      to={{
                        pathname: `/event/${item.eventid}/tickets`,
                        state: {
                          is_sponsorship: item.is_sponsorship,
                          campaignStatus: item.campaignStatus ?? 'running',
                          fromHome: true,
                          eventid: item.eventid,
                          eventDate: item.event_day,
                          event_date: item.event_day,
                          enddate: item.finish_day,
                          finish_date: item.finish_day,
                          fulldate,
                          customerid: 0,
                          posterUri,
                          accountid: 0,
                          accounttype: '',
                          customername: '',
                          email: '',
                          phone: '',
                          venue: item.event_location,
                          description: item.event_des,
                          businessid: item.businessid,
                          poster: item.poster,
                          eventname: item.eventname,
                          eventday: item.eventday,
                          starttime: item.start_time,
                          endtime: item.finish_time,
                          previousPage: window.location.pathname.replace(/\\|\//g, ''),
                          category: '',
                        },
                      }}
                      className="kx-header__search-result"
                      onClick={() => setSearchOpen(false)}
                    >
                      <div className="kx-header__result-row">
                        <div className="kx-header__result-poster">
                          {item.poster ? (
                            <img src={posterUri} alt="" />
                          ) : (
                            <div className="kx-header__result-poster-empty" />
                          )}
                        </div>

                        <div className="kx-header__result-info">
                          <div className="kx-header__result-title">
                            <span>{eventName}</span>

                            {item.is_sponsorship == 1 && (
                              <span className="kx-header__sponsored">
                                <IoStar size={11} />
                              </span>
                            )}
                          </div>

                          <div className="kx-header__result-host">
                            <span>Host:</span> {businessName}
                          </div>
                        </div>

                        <span className="kx-header__result-arrow">→</span>
                      </div>
                    </Link>
                  )
                })
              )}
            </div>
          )}
        </div>

        {/* =====================================================
            RIGHT SIDE
        ===================================================== */}

        <div className="kx-header__right">
          <nav className="kx-header__guest-nav">
            <Link to="/fees">Pricing</Link>
            <Link to="/aboutkaramale">About</Link>
          </nav>

          <div className="kx-header__account kx-header__account--guest" ref={dropdownRef}>
            <button type="button" className="kx-header__account-trigger" onClick={toggleDropdown}>
              <span className="kx-header__avatar">
                <FiUser size={17} />
              </span>

              <span className="kx-header__account-copy">
                <span className="kx-header__account-name">Guest</span>
              </span>

              <BiChevronDown
                className={`kx-header__account-arrow ${
                  dropdownOpen ? 'kx-header__account-arrow--open' : ''
                }`}
                size={20}
              />
            </button>

            {dropdownOpen && (
              <div className="kx-header__dropdown">
                <div className="kx-header__dropdown-heading">KARAMALE</div>

                <Link to="/login" onClick={() => setDropdownOpen(false)}>
                  <span>Log In</span>
                  <span>→</span>
                </Link>

                <Link to="/registration" onClick={() => setDropdownOpen(false)}>
                  <span>Create Account</span>
                  <span>→</span>
                </Link>

                <div className="kx-header__dropdown-divider" />

                <Link to="/aboutkaramale" onClick={() => setDropdownOpen(false)}>
                  <span>About</span>
                  <span>→</span>
                </Link>

                <Link to="/fees" onClick={() => setDropdownOpen(false)}>
                  <span>Pricing</span>
                  <span>→</span>
                </Link>

                <Link to="/budget" onClick={() => setDropdownOpen(false)}>
                  <span>Calculate</span>
                  <span>→</span>
                </Link>

                <Link to="/aboutsalesparnter" onClick={() => setDropdownOpen(false)}>
                  <span>Affiliate Program</span>
                  <span>→</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
